define('responsive-gameday/controllers/PitchFXViewController',['require','exports','module','Responsive/controllers/ViewController','responsive-pitch-fx/responsive-pitch-fx','../views/render/PitchFXViewRender','Responsive/util/renderComplete','Responsive/vendor','../views/Monitor/Events/ViewModelUpdateEvents','message-service/message-service','responsive-gameday-tracking/responsive-gameday-tracking','image-loader/image-loader','jquery-when-always/jquery-when-always','GameDayCore','extant/extant'],function(require,exports,module) {
    // Add private variables here
    var ViewController = require("Responsive/controllers/ViewController"),
        PitchEffectsLayer = require("responsive-pitch-fx/responsive-pitch-fx"),
        PitchFXViewRender = require( '../views/render/PitchFXViewRender' ),
        renderComplete = require("Responsive/util/renderComplete"),
        vendor = require( 'Responsive/vendor' ),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service"),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        imageLoader = require("image-loader/image-loader"),
        $ = require( 'jquery-when-always/jquery-when-always' ),
        GDC = require("GameDayCore"),
        exists = require( 'extant/extant' );

    var Superclass;

    // Constructor
    function PitchFXViewController(opts) {
        // Call super constructor
        Superclass.constructor.call(this);
        this.referenceName = "pitchfx";
        this.viewRender = new PitchFXViewRender();
        this.pitchLayer = null;
        this.stadium = null;
        this.phase = null;
        this.tabTitle = "Live";
        this.emitter = MessageService.bind(this);
        this.onBeat = function(payload,evt){
            this.drawField(payload,evt);
        }

        MessageService.publish("registerViewComponent", this);
    }

    // Prototype Inheritence
    ViewController.spawn(PitchFXViewController).define({
        loadView: function () {
            Superclass.loadView.call(this);
            this.setClassName("PitchFXViewController");
            this.stadiumId = null;
        },

        drawField: function (payload) {

            var self = this,
                field = this.getView().querySelector('.pitch_fx .field');

            if (!field || !this.pitchLayer) {
                return;
            }
            if(this.stadiumId && this.stadiumId===payload.stadium.id){
                if(Object.keys(payload.atbat).length){
                    // If there's an atbat to show, draw it
                    this.pitchLayer.draw(payload.atbat,payload.hotcoldzone);
                    this.hideOverlay();
                } else {
                    // no current atbat, clear the deck!
                    this.pitchLayer.clearAll();
                }
            } else{
                $(self.getView()).off('click mouseenter', '.responsive-pitch-fx-ball')
                    .on("mouseenter", ".responsive-pitch-fx-ball",function(){
                        Tracking.track_pitches_activity()
                    })
                    .on('click', '.responsive-pitch-fx-ball', function() {
                        $(this).toggleClass('active');
                    });



                if (field && payload.stadium) {
                    self.phase  = payload.dayOrNight;
                    self.stadium=payload.stadium;
                    self.stadiumImages = payload.getStadiumImages(field);
                    self.pitchLayer.config.oldTimey = !!payload.oldTimey;
                    self.pitchLayer.anchor(field);
                    $(field).parent('.stadium').removeClass('day night').addClass(payload.dayOrNight);
                    
                    $.whenAlways(imageLoader.load(self.stadiumImages.bottom), imageLoader.load(self.stadiumImages.top)).then(function (_bottom, _top) {
                        if (field) {
                            field.style.backgroundImage = "url('" + self.stadiumImages.bottom + "'), url('" + self.stadiumImages.top + "')";
                        }
                    },function (_bottom, fail) {
                        if (field) {
                            field.style.backgroundImage = "url('" + self.stadiumImages.bottom + "'), url('" + self.stadiumImages.defaultTop + "')";
                        }
                    }).always(function () {
                        if (field && self.isViewLoaded()) {
                            self.stadiumId=payload.stadium.id;

                            if (!payload.hasPitchFX) {
                                field.parentNode.setAttribute('data-gameday-message', "Limited Gameday experience for this game.");
                            } else {
                                field.parentNode.removeAttribute('data-gameday-message');
                            }

                            field.style.opacity = 1;
                            setTimeout(function(){
                                if(field && field.style.backgroundImage){
                                    field.style[vendor.transitionJS] = "all 500ms ease-in-out, background 1s ease-in-out";
                                }
                            },800);
                            self.pitchLayer.draw(payload.atbat,payload.hotcoldzone);
                            self.layerDrawn();
                            self.hideOverlay();
                        }
                    });
                }
            }
        },

        viewWillAppear: function () {
            var self=this;
            if(this.pitchLayer){
                this.pitchLayer.destroy();
            }
            this.pitchLayer= new PitchEffectsLayer();

            Superclass.viewWillAppear.call(this);
            this.showOverlay();
            this.view.innerHTML = this.viewRender.render({});
            renderComplete(function(){
                MessageService.on.call(self,VMEvents.UPDATE_PITCHFX, self.onBeat);
                MessageService.publish(VMEvents.REQUEST_PITCHFX_DATA);
            });

        },

        viewWillDisappear: function () {
            var self = this;

            MessageService.off(VMEvents.UPDATE_PITCHFX,this.onBeat);
            Superclass.viewWillDisappear.call(this);
            this.fieldTopUrl = null;
            if (this.pitchLayer) {
                this.pitchLayer.destroy();
                this.pitchLayer=null;
            }
        },
        layerDrawn : function(){
            this.emitter.publish("PitchFXLayerDrawn");
        }
    });

    Superclass = PitchFXViewController.superclass;

    return PitchFXViewController;
});

